import React from "react";
import tw from "tailwind-styled-components";
import Model from "../Model";
import moment from "moment";
import Config from "../../Config";

const ViewModel = ({ setOpenViewModel, selectedItem, serviceType }) => {
  return (
    <Model width={"w-11/12 max-w-2xl"} setOpenModel={setOpenViewModel}>
      <Wrapper>
        <Title>View Details</Title>
        <SingleItem name={"Assoc Name"} value={selectedItem?.assocName} />
        <SingleItem name={"Remarks"} value={selectedItem?.remarks || "OK"}  />
        <SingleItem name={"Dated"} value={selectedItem?.dated} />
        <SingleItem name={"Created Date"} value={moment(selectedItem?.creationOn).format("DD-MM-YYYY hh:mm A")} />
      
        {serviceType == 1 &&
        <>
        <SingleItem name={"Article No"} value={selectedItem?.articleNumber} />
        <SingleItem name={"Reason"} value={selectedItem?.reason} />
        {selectedItem.matrixForm && 
            <SingleItem name={"Matrix Form"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.matrixForm )} target="_blank">Matrix Form</a>
            </LinkValue>} />
          }
        {selectedItem.registrarSign && 
            <SingleItem name={"Registerar Signature"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.registrarSign )} target="_blank">Registerar Signature</a>
            </LinkValue>} />
          }
        </>
        }

        {serviceType == 2 &&
        <>
          <SingleItem name={"Article No"} value={selectedItem?.articleNumber} />
          <SingleItem name={"Reason"} value={selectedItem?.reason} />
          {selectedItem.mom && 
            <SingleItem name={"Minutes of Meeting"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.mom )} target="_blank">M.O.M</a>
            </LinkValue>} />
          }
          {selectedItem.matrixForm && 
            <SingleItem name={"Matrix Form"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.matrixForm )} target="_blank">Matrix Form</a>
            </LinkValue>} />
          }
          {selectedItem.chairmanSignature && 
            <SingleItem name={"Chairman Signature"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.chairmanSignature )} target="_blank">Chairman Signature</a>
            </LinkValue>} />
          }
          {selectedItem.secretarySignature && 
            <SingleItem name={"Secretary Signature"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.secretarySignature )} target="_blank">Secretary Signature</a>
            </LinkValue>} />
          }
        </>
        }
        {serviceType == 3 &&
        <>
          <SingleItem name={"New Name"} value={selectedItem?.newName} />
          <SingleItem name={"Reason"} value={selectedItem?.reason} />
          {selectedItem.mom && 
            <SingleItem name={"Minutes of Meeting"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.mom )} target="_blank">M.O.M</a>
            </LinkValue>} />
          }
          {selectedItem.chairmanSignature && 
              <SingleItem name={"Chairman Signature"} value={ 
              <LinkValue>
              <a  href= {(Config.docUrl + selectedItem.chairmanSignature )} target="_blank">Chairman Signature</a>
              </LinkValue>} />
            }
            {selectedItem.secretarySignature && 
              <SingleItem name={"Secretary Signature"} value={ 
              <LinkValue>
              <a  href= {(Config.docUrl + selectedItem.secretarySignature )} target="_blank">Secretary Signature</a>
              </LinkValue>} />
            }

        </>
        }
        {serviceType == 4 &&
        <>
          <SingleItem name={"Establishment Date"} value={selectedItem?.establishmentDate} />
          <SingleItem name={"Old Address"} value={selectedItem?.oldAddress} />
          <SingleItem name={"New Address"} value={selectedItem?.newAddress} />
          {/* <SingleItem name={"Reason"} value={selectedItem?.reason} /> */}
          {selectedItem.mom && 
            <SingleItem name={"Minutes of Meeting"} value={ 
            <LinkValue>
            <a  href= {(Config.docUrl + selectedItem.mom )} target="_blank">M.O.M</a>
            </LinkValue>} />
          }
          {selectedItem.chairmanSignature && 
              <SingleItem name={"Chairman Signature"} value={ 
              <LinkValue>
              <a  href= {(Config.docUrl + selectedItem.chairmanSignature )} target="_blank">Chairman Signature</a>
              </LinkValue>} />
            }
            {selectedItem.secretarySignature && 
              <SingleItem name={"Secretary Signature"} value={ 
              <LinkValue>
              <a  href= {(Config.docUrl + selectedItem.secretarySignature )} target="_blank">Secretary Signature</a>
              </LinkValue>} />
            }

        </>
        }
        {selectedItem.certificateName && 
              <SingleItem name={"Certificate"} value={ 
              <LinkValue>
              <a  href= {(Config.docUrl + selectedItem.certificateName )} target="_blank">Download Certificate</a>
              </LinkValue>} />
        }
        </Wrapper>
    </Model>
  );
};

const SingleItem = ({ name, value, link, url }) => (
  <div className="flex items-center py-2 border-b border-gray-100 ">
    <Name>{name}</Name> <p className="w-10">:</p>
    {link && (
      <LinkValue href={url} target="_blank" title="Click to open">
        {value}
      </LinkValue>
    )}
    {!link && <Value>{value}</Value>}
  </div>
);

const Wrapper = tw.div`px-4`;
const Title = tw.h2`text-lg md:text-xl mb-6 text-gray-700 font-medium text-left`;
const Name = tw.p`text-sm text-gray-500  w-40`;
const Value = tw.p`text-sm text-gray-800 font-medium max-w-xs `;
const LinkValue = tw.a`text-sm text-blue-500 max-w-xs truncate cursor-pointer`;
const BtnWrapper = tw.div` w-full flex items-center justify-end space-x-10 mt-8`;

export default ViewModel;
